export default __webpack_public_path__ + "static/bangalore-cover-c5a2d12f55a914949274e2b00e411bd6.jpg";